import { render, staticRenderFns } from "./EventStatePastWarning.vue?vue&type=template&id=4d10b5c4&"
import script from "./EventStatePastWarning.vue?vue&type=script&lang=js&"
export * from "./EventStatePastWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports